<div class="special-hours__container">
  <div class="special-hours__container__day">
    <span>{{ displaySelectedDate }}</span>
  </div>
  <div class="special-hours__container__times" *ngIf="isClosed">
    <span class="special-hours__container__time-span">
      {{ 'FRONTEND.FORMS.HOURS_OF_OPERATION.CLOSED' | translate }}
    </span>
  </div>
  <div class="special-hours__container__times" *ngIf="isOpen">
    <span class="special-hours__container__time-span" *ngFor="let timeSpan of displayTimeSpan">
      @if (timeSpan.is24Hours) {
        <span>
          {{ 'FRONTEND.FORMS.HOURS_OF_OPERATION.ALL_DAY' | translate }}
        </span>
      } @else {
        <span class="time-span">
          <span class="time-span__opens">{{ displayTime(timeSpan.startTime) }}</span>
          <span class="time-span__divider">&nbsp;&#8212;&nbsp;</span>
          <span class="time-span__closes">{{ displayTime(timeSpan.endTime) }}</span>
        </span>
      }
    </span>
  </div>
</div>
